import { clsx } from 'clsx';
import { type FC, type ReactNode } from 'react';

import styles from './BenefitCard.css';

type BenefitCardProps = {
  description: ReactNode;
  icon: 'building' | 'education' | 'favorite';
  title: string;
};

export const BenefitCard: FC<BenefitCardProps> = ({ description, icon, title }) => (
  <article className={styles['container']} data-testid="pik-in-numbers-benefit-card">
    <div aria-hidden="true" className={styles['icon-container']}>
      <span className={clsx(styles['icon'], styles[`icon--${icon}`])} />
    </div>
    <strong className={styles['title']}>{title}</strong>
    <span className={styles['description']}>{description}</span>
  </article>
);
